import {
  esri,
  lvnl,
  mapboxStyle,
  mapy,
  openaip,
  tomtom,
} from '../urls'
import { createLayer } from '../../layers/factory'

export const overLayers = createLayer({
  type: 'group',
  title: 'Overlayers',
  layers: [
    {
      title: 'Nederland Grenzen',
      type: 'group',
      layers: [
        {
          title: 'BGT Omtrek (ZOOM IN!)',
          type: 'wmts',
          url: 'https://service.pdok.nl/lv/bgt/wmts/v1_0?service=WMTS&',
          projection: 'EPSG:28992',
          source: {
            layer: 'omtrekgerichtevisualisatie',
          },
          layer: {
            minZoom: 16.5,
            maxZoom: 19.5,
          },
        },
        {
          title: 'Gemeentegrenzen',
          type: 'wms',
          url: 'https://service.pdok.nl/kadaster/bestuurlijkegebieden/wms/v1_0?service=WMS&',
          layers: 'Gemeentegebied',
        },
        {
          title: 'Landsgrens',
          type: 'wms',
          url: 'https://service.pdok.nl/kadaster/bestuurlijkegebieden/wms/v1_0?service=WMS&',
          layers: 'Landgebied',
        },
        {
          title: 'Provinciegrenzen',
          type: 'wms',
          url: 'https://service.pdok.nl/kadaster/bestuurlijkegebieden/wms/v1_0?service=WMS&',
          layers: 'Provinciegebied',
        },
        {
          title: 'Waterschappen',
          type: 'wms',
          url: 'https://service.pdok.nl/hwh/administratieve-eenheden/waterschapsgrenzen/wms/v1_0?',
          layers: 'AU.AdministrativeUnit',
          source: {
            params: {
              STYLES: 'AU.AdministrativeUnit.Alternative',
            },
          },
        },
        {
          title: 'Veiligheidsregio (2025)',
          type: 'wms',
          url: 'https://service.pdok.nl/cbs/gebiedsindelingen/2025/wms/v1_0?',
          layers: 'veiligheidsregio_gegeneraliseerd,veiligheidsregio_labelpoint',
        },
        {
          title: 'GGD Regio (2025)',
          type: 'wms',
          url: 'https://service.pdok.nl/cbs/gebiedsindelingen/2025/wms/v1_0?',
          layers: 'ggdregio_gegeneraliseerd,ggdregio_labelpoint',
        },
        {
          title: 'Existing Land Use',
          type: 'wms',
          url: 'https://service.pdok.nl/cbs/landuse/wms/v1_0?',
          layers: 'LU.ExistingLandUse',
          layer: {
            minZoom: 12.5,
          },
        },
      ],
    },
    {
      title: 'Nederland Wegen',
      type: 'group',
      layers: [
        {
          title: 'RWS Metrering Wegen',
          type: 'arcgisrest',
          url: 'https://geo.rijkswaterstaat.nl/arcgis/rest/services/GDR/nwb_metrering/MapServer',
          layers: 'show:0,1,2,3',
        },
        {
          title: 'Hectometerpalen ICM',
          type: 'wms',
          url: 'https://geoserver.stichtingimn.nl/geoserver/ows?',
          layers: 'bps:bps_palen',
          source: {
            params: {
              TILED: true,
              VERSION: '1.1.1',
            },
          },
        },
        {
          title: 'NWB - Hectopunten',
          type: 'wms',
          url: 'https://service.pdok.nl/rws/nwbwegen/wms/v1_0?',
          layers: 'hectopunten',
        },
      ],
    },
    {
      title: 'Nederland Water',
      type: 'group',
      layers: [
        {
          title: 'RWS Strandpalen MapServer',
          type: 'arcgisrest',
          url: 'https://geo.rijkswaterstaat.nl/arcgis/rest/services/GDR/kustlijnzorg/MapServer',
          layers: 'show:2,12',
        },
        {
          title: 'RWS Maritime Chart Service',
          type: 'arcgisrest',
          url: 'https://geo.rijkswaterstaat.nl/arcgis/rest/services/ENC/mcs_inland/MapServer/exts/MaritimeChartService/MapServer',
        },
        {
          title: 'RWS Metrering Vaarwegen',
          type: 'arcgisrest',
          url: 'https://geo.rijkswaterstaat.nl/arcgis/rest/services/GDR/nwb_metrering/MapServer',
          layers: 'show:4,5',
        },
        {
          title: 'Noordzee Vaarwegmarkeringen Drijvend',
          type: 'wms',
          url: 'https://service.pdok.nl/rws/vaarwegmarkeringennld/wms/v1_0?',
          layers: 'markdrijvendrd',
        },
        {
          title: 'Noordzee Vaarwegmarkeringen Vast',
          type: 'wms',
          url: 'https://service.pdok.nl/rws/vaarwegmarkeringennld/wms/v1_0?',
          layers: 'markvastrd',
        },
        {
          title: 'NWB Vaarwegen - KM markers',
          type: 'wms',
          url: 'https://service.pdok.nl/rws/nwbvaarwegen/wms/v1_0?',
          layers: 'kmmarkeringen',
          layer: {
            minZoom: 13.5,
          },
        },
        {
          title: 'NWB Vaarwegen - Vakken',
          type: 'wms',
          url: 'https://service.pdok.nl/rws/nwbvaarwegen/wms/v1_0?',
          layers: 'vaarwegvakken',
        },
        {
          title: 'VNDS - Bevaarbaarheid',
          type: 'wms',
          url: 'https://service.pdok.nl/rws/vnds/wms/v2_0?',
          layers: 'l_navigability',
          source: {
            styles: 'inspire_common:DEFAULT',
          },
        },
        {
          title: 'Zwemwaterkwaliteit',
          type: 'wms',
          url: 'https://pubgeo.zwemwater.nl/geoserver/zwr_public/wms',
          layers: 'zwemplekken',
        },
        {
          title: 'Zwemwaterkwaliteit pdok',
          type: 'wms',
          url: 'https://service.pdok.nl/provincies/zwemwaterkwaliteit-provinciaal-rijkswateren/wms/v1_0?service=wms&',
          layers: 'HH.HealthDeterminantMeasure',
        },
        {
          title: 'Zwemwater',
          type: 'wms',
          url: 'https://service.pdok.nl/provincies/zwemwater-provinciaal-rijkswateren/wms/v1_0?service=WMS&',
          layers: 'AM.DesignatedWaters',
        },
        {
          title: 'Vergunde ontgrondingsgebieden',
          type: 'wms',
          url: 'https://service.pdok.nl/provincies/begrenzingen-vergunde-ontgrondingsgebieden-zand-grindwinning/wms/v1_0?service=wms&',
          layers: 'AM.ProspectingAndMiningPermitArea',
        },
        {
          title: 'Grondwaterbeschermingsgebieden',
          type: 'wms',
          url: 'https://service.pdok.nl/provincies/grondwaterbeschermingsgebieden/wms/v1_0?service=wms&',
          layers: 'AM.DrinkingWaterProtectionArea',
        },
        {
          title: 'Verkeersscheidingsstelsel Noordzee',
          type: 'group',
          layers: [
            {
              title: 'Ankergebieden',
              type: 'wms',
              url: 'https://service.pdok.nl/rws/verkeersscheidingsstelsel/wms/v1_0?service=WMS',
              layers: 'ankergebieden',
            },
            {
              title: 'Begrenzing en Seperatiezones',
              type: 'wms',
              url: 'https://service.pdok.nl/rws/verkeersscheidingsstelsel/wms/v1_0?service=WMS',
              layers: 'begrenzing,seperatiezones',
            },
            {
              title: 'Kilometreringlabels',
              type: 'wms',
              url: 'https://service.pdok.nl/rws/verkeersscheidingsstelsel/wms/v1_0?service=WMS',
              layers: 'kilometreringlabels',
            },
            {
              title: 'Vaargeulen',
              type: 'wms',
              url: 'https://service.pdok.nl/rws/verkeersscheidingsstelsel/wms/v1_0?service=WMS',
              layers: 'vaargeulenpertypeentiteit',
            },
          ],
        },

      ],
    },
    {
      title: 'Nederland Spoor',
      type: 'group',
      layers: [
        {
          title: 'Kilometrering',
          type: 'wms',
          url: 'https://service.pdok.nl/prorail/spoorwegen/wms/v1_0?',
          layers: 'kilometrering',
        },
        {
          title: 'Kruising',
          type: 'wms',
          url: 'https://service.pdok.nl/prorail/spoorwegen/wms/v1_0?',
          layers: 'kruising',
        },
        {
          title: 'Overweg',
          type: 'wms',
          url: 'https://service.pdok.nl/prorail/spoorwegen/wms/v1_0?',
          layers: 'overweg',
        },
        {
          title: 'Spooras',
          type: 'wms',
          url: 'https://service.pdok.nl/prorail/spoorwegen/wms/v1_0?',
          layers: 'spooras',
        },
        {
          title: 'Station',
          type: 'wms',
          url: 'https://service.pdok.nl/prorail/spoorwegen/wms/v1_0?',
          layers: 'station',
        },
        {
          title: 'Trace',
          type: 'wms',
          url: 'https://service.pdok.nl/prorail/spoorwegen/wms/v1_0?',
          layers: 'trace',
        },
        {
          title: 'Wissel',
          type: 'wms',
          url: 'https://service.pdok.nl/prorail/spoorwegen/wms/v1_0?',
          layers: 'wissel',
        },
      ],
    },
    {
      title: 'ProRail',
      type: 'group',
      layers: [
        {
          title: 'Basiskaart',
          type: 'arcgisrest',
          url: 'https://maps.prorail.nl/arcgis/rest/services/ProRail_basiskaart/MapServer',
          layers: 'show:0,1,2,4,5,6,7,8,9',
        },
        {
          title: 'Afscherming',
          type: 'arcgisrest',
          url: 'https://maps.prorail.nl/arcgis/rest/services/Afscherming/MapServer',
          layers: 'show:0,1,2,4,5,6,7,8,9',
          layer: {
            minZoom: 17.5,
          },
        },
        {
          title: 'Bedrijfsnoodplan',
          type: 'arcgisrest',
          url: 'https://maps.prorail.nl/arcgis/rest/services/Bedrijfsnoodplan/MapServer',
          layer: {
            minZoom: 15.5,
          },
        },
        {
          title: 'Energievoorzieningsysteem',
          type: 'arcgisrest',
          url: 'https://maps.prorail.nl/arcgis/rest/services/Energievoorzieningsysteem/MapServer',
          layer: {
            minZoom: 11.5,
          },
        },
        {
          title: 'Kabelsituatie',
          type: 'arcgisrest',
          url: 'https://maps.prorail.nl/arcgis/rest/services/Kabelsituatie/MapServer',
          layer: {
            minZoom: 15.5,
          },
        },
        {
          title: 'Treinbeveiligingsysteem ',
          type: 'arcgisrest',
          url: 'https://maps.prorail.nl/arcgis/rest/services/Treinbeveiligingsysteem/MapServer',
          layer: {
            minZoom: 17.5,
          },
        },
        {
          title: 'Water- en Brandleidingen ',
          type: 'arcgisrest',
          url: 'https://maps.prorail.nl/arcgis/rest/services/Water__en_Brandleidingen/MapServer',
          layer: {
            minZoom: 15.5,
          },
        },
      ],
    },
    {
      title: 'Nederland Vliegen',
      type: 'group',
      // Luchtverkeersleiding Nederland
      // https://geoservices.lvnl.nl/arcgis/rest/services
      layers: [
        {
          title: 'LVNL Flight Information Service',
          type: 'arcgisrest',
          url: lvnl() + 'VFRchart/FIS/MapServer',
          layers: 'show:0,1',
        },
        {
          title: 'LVNL Navaids',
          type: 'arcgisrest',
          url: lvnl() + 'VFRchart/Navaids/MapServer',
          layers: 'show:0,1,2,3,4',
        },
        {
          title: 'LVNL Runways',
          type: 'arcgisrest',
          url: lvnl() + 'VFRchart/Aerodrome/MapServer',
          layers: 'show:0',
        },
        {
          title: 'LVNL Airports',
          type: 'arcgisrest',
          url: lvnl() + 'VFRchart/Aerodrome/MapServer',
          layers: 'show:3',
        },
        {
          title: 'LVNL Landingsites',
          type: 'arcgisrest',
          url: lvnl() + 'VFRchart/Aerodrome/MapServer',
          layers: 'show:8',
        },
        {
          title: 'LVNL Routes VFR',
          type: 'arcgisrest',
          url: lvnl() + 'VFRchart/Routes/MapServer',
          layers: 'show:0,1,2',
        },
        {
          title: 'LVNL Routes Military Low Flying',
          type: 'arcgisrest',
          url: lvnl() + 'VFRchart/Routes/MapServer',
          layers: 'show:3',
        },
        {
          title: 'LVNL Obstacles',
          type: 'arcgisrest',
          url: lvnl() + 'VFRchart/Obstacles/MapServer',
          layers: 'show:0,1',
        },
        {
          title: 'LVNL Miscellaneous',
          type: 'arcgisrest',
          url: lvnl() + 'VFRchart/Miscellaneous/MapServer',
          layers: 'show:0,1,2,3,4,5',
        },
        {
          title: 'LVNL Airspaces - Flight Information Region',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:0',
        },
        {
          title: 'LVNL Airspaces - Low Flying Area',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:1',
        },
        {
          title: 'LVNL Airspaces - Prohibited Areas',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:3',
        },
        {
          title: 'LVNL Airspaces - Restricted Areas',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:4',
        },
        {
          title: 'LVNL Airspaces - Danger Areas',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:5',
        },
        {
          title: 'LVNL Airspaces - Temporary Reserved Airspace',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:6',
        },
        {
          title: 'LVNL Airspaces - Temporary Segregated Area',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:7',
        },
        {
          title: 'LVNL Airspaces - Parajump',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:8',
        },
        {
          title: 'LVNL Airspaces - Aerodrome Traffic Zones',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:9',
        },
        {
          title: 'LVNL Airspaces - Transponder Mandatory zone',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:10',
        },
        {
          title: 'LVNL Airspaces - Airway',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:11',
        },
        {
          title: 'LVNL Airspaces - Helicopter Protection/Traffic Zone',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:12',
        },
        {
          title: 'LVNL Airspaces - Radio Mandatory Zone',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:13',
        },
        {
          title: 'LVNL Airspaces - Glider Areas',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:14',
        },
        {
          title: 'LVNL Airspaces - Control Area',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:15',
        },
        {
          title: 'LVNL Airspaces - Terminal Control Area',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:16',
        },
        {
          title: 'LVNL Airspaces - Control Zone',
          type: 'arcgisrest',
          url: lvnl(true),
          layers: 'show:17',
        },
        {
          title: 'Geluidszones rondom vliegvelden',
          type: 'wms',
          url: 'https://service.pdok.nl/provincies/geluidzones-rondom-vliegvelden/wms/v1_0?service=wms&',
          layers: 'AM.NoiseRestrictionZone',
        },
      ],
    },
    {
      title: 'ESRI',
      type: 'group',
      layers: [
        {
          title: 'Boundaries and Places Alternate',
          type: 'xyz',
          url: esri('Reference/World_Boundaries_and_Places_Alternate'),
        },
        {
          title: 'Boundaries and Places',
          type: 'xyz',
          url: esri('Reference/World_Boundaries_and_Places'),
        },
        {
          title: 'Reference Overlay',
          type: 'xyz',
          url: esri('Reference/World_Reference_Overlay'),
          layer: {
            maxZoom: 11,
          },
          source: {
            maxZoom: 9,
          },
        },
        {
          title: 'Transportation',
          type: 'xyz',
          url: esri('Reference/World_Transportation'),
        },
        {
          title: 'Canvas Dark Gray Reference',
          type: 'xyz',
          url: esri('Canvas/World_Dark_Gray_Reference'),
        },
        {
          title: 'Canvas Light Gray Reference',
          type: 'xyz',
          url: esri('Canvas/World_Light_Gray_Reference'),
        },
        {
          title: 'Oceans Reference',
          type: 'xyz',
          url: esri('Ocean/World_Ocean_Reference'),
        },
        // {
        //   title: 'Elevation Hillshade',
        //   type: 'xyz',
        //   url: esri('Elevation/World_Hillshade'),
        // },
        // {
        //   title: 'Elevation Hillshade Dark',
        //   type: 'xyz',
        //   url: esri('Elevation/World_Hillshade_Dark'),
        // },
      ],
    },
    {
      title: 'Stamen/StadiaMaps',
      type: 'group',
      layers: [
        {
          title: 'Stamen Terrain Labels',
          type: 'stadia',
          source: {
            layer: 'stamen_terrain_labels',
          },
        },
        {
          title: 'Stamen Terrain Lines',
          type: 'stadia',
          source: {
            layer: 'stamen_terrain_lines',
          },
        },
        {
          title: 'Stamen Toner Labels',
          type: 'stadia',
          source: {
            layer: 'stamen_toner_labels',
          },
        },
        {
          title: 'Stamen Toner Lines',
          type: 'stadia',
          source: {
            layer: 'stamen_toner_lines',
          },
        },
      ],
    },
    {
      title: 'TomTom',
      type: 'group',
      layers: [
        {
          title: 'Hybrid Main',
          type: 'xyz',
          url: tomtom('hybrid/main'),
        },
        {
          title: 'Hybrid Night',
          type: 'xyz',
          url: tomtom('hybrid/night'),
        },
      ],
    },
    {
      title: 'Open Railway Map',
      type: 'group',
      // crossOrigin: null - makes it work inside canvas
      // tilePixelRatio: 2 - server returns 512px img for 256 tiles
      layers: [
        {
          title: 'Infrastructure',
          type: 'xyz',
          url: 'https://{a-c}.tiles.openrailwaymap.org/standard/{z}/{x}/{y}.png',
          source: {
            opaque: false,
            crossOrigin: null,
            tilePixelRatio: 2,
            maxZoom: 19,
          },
        },
        {
          title: 'Max Speeds',
          type: 'xyz',
          url: 'https://{a-c}.tiles.openrailwaymap.org/maxspeed/{z}/{x}/{y}.png',
          source: {
            opaque: false,
            crossOrigin: null,
            tilePixelRatio: 2,
            maxZoom: 19,
          },
        },
        {
          title: 'Signalling',
          type: 'xyz',
          url: 'https://{a-c}.tiles.openrailwaymap.org/signals/{z}/{x}/{y}.png',
          source: {
            opaque: false,
            crossOrigin: null,
            tilePixelRatio: 2,
            maxZoom: 19,
          },
        },
      ],
    },
    {
      title: 'NL Fiets- en Wandelnetwerken',
      type: 'group',
      layers: [
        {
          title: 'Regionale wandelnetwerken',
          type: 'wms',
          url: 'https://service.pdok.nl/wandelnet/regionale-wandelnetwerken/wms/v1_0?version=1.3.0&service=wms&',
          layers: 'wandelnetwerken,wandelknooppunten',
        },
        {
          title: 'Regionale fietsnetwerken',
          type: 'wms',
          url: 'https://service.pdok.nl/fietsplatform/regionale-fietsnetwerken/wms/v1_0?version=1.3.0&service=wms&',
          layers: 'fietsnetwerken,fietsknooppunten',
        },
        {
          title: 'Landelijke fietsroutes',
          type: 'wms',
          url: 'https://service.pdok.nl/fietsplatform/landelijke-fietsroutes/wms/v1_0?version=1.3.0&service=wms&',
          layers: 'landelijke-fietsroutes',
        },
        {
          title: 'Landelijke wandelroutes',
          type: 'wms',
          url: 'https://service.pdok.nl/wandelnet/landelijke-wandelroutes/wms/v1_0?version=1.3.0&service=wms&',
          layers: 'landelijke-wandelroutes',
        },
        {
          title: 'Landelijke wandelroutes ns-wandelingen',
          type: 'wms',
          url: 'https://service.pdok.nl/wandelnet/landelijke-wandelroutes/wms/v1_0?version=1.3.0&service=wms&',
          layers: 'ns-wandelingen',
        },
        {
          title: 'Landelijke wandelroutes ov-stappers',
          type: 'wms',
          url: 'https://service.pdok.nl/wandelnet/landelijke-wandelroutes/wms/v1_0?version=1.3.0&service=wms&',
          layers: 'ov-stappers',
        },
        {
          title: 'Landelijke wandelroutes stad-te-voet',
          type: 'wms',
          url: 'https://service.pdok.nl/wandelnet/landelijke-wandelroutes/wms/v1_0?version=1.3.0&service=wms&',
          layers: 'stad-te-voet',
        },
        {
          title: 'Landelijke wandelroutes streekpaden',
          type: 'wms',
          url: 'https://service.pdok.nl/wandelnet/landelijke-wandelroutes/wms/v1_0?version=1.3.0&service=wms&',
          layers: 'streekpaden',
        },
      ],
    },
    {
      title: 'Waymaked Trails',
      type: 'group',
      layers: [
        {
          title: 'Wandelen',
          type: 'xyz',
          url: 'https://tile.waymarkedtrails.org/hiking/{z}/{x}/{y}.png',
          source: {
            opaque: false,
          },
        },
        {
          title: 'Fietsen',
          type: 'xyz',
          url: 'https://tile.waymarkedtrails.org/cycling/{z}/{x}/{y}.png',
          source: {
            opaque: false,
          },
        },
        {
          title: 'Mountainbiken',
          type: 'xyz',
          url: 'https://tile.waymarkedtrails.org/mtb/{z}/{x}/{y}.png',
          source: {
            opaque: false,
          },
        },
        {
          title: 'Paardrijden',
          type: 'xyz',
          url: 'https://tile.waymarkedtrails.org/riding/{z}/{x}/{y}.png',
          source: {
            opaque: false,
          },
        },
        {
          title: 'Wintersportpistes',
          type: 'xyz',
          url: 'https://tile.waymarkedtrails.org/slopes/{z}/{x}/{y}.png',
          source: {
            opaque: false,
          },
        },
      ],
    },
    {
      title: 'OpenAIP',
      type: 'group',
      layers: [
        {
          title: 'OpenAIP',
          type: 'xyz',
          url: openaip,
        },
        {
          title: 'ADSB OpenAIP',
          type: 'xyz',
          url: 'https://map.adsbexchange.com/mapproxy/tiles/1.0.0/openaip/ul_grid/{z}/{x}/{y}.png',
          layer: {
            type: 'overlay',
            opacity: 0.7,
          },
        },
      ],
    },
    {
      title: 'risicokaart.nl',
      type: 'group',
      // https://rev-portaal.nl/geoserver/wms/rev_public?SERVICE=WMS&VERSION=1.3.0&REQUEST=getcapabilities
      layers: [
        {
          // Deprecated: uit productie per 25 mei 2026
          title: 'Waterkering',
          type: 'wms',
          url: 'https://service.pdok.nl/hwh/keringenimwa/wms/v2_0',
          layers: 'waterkering',
        },
        {
          // Deprecated: uit productie per 25 mei 2026
          title: 'Waterkering v3',
          type: 'wms',
          url: 'https://service.pdok.nl/hwh/waterschappen-keringen-imwa/wms/v3_0',
          layers: 'waterkering',
          layer: {
            minZoom: 13.5,
          },
        },
        {
          title: 'Significant overstromingsrisico gebied',
          type: 'wms',
          url: 'https://geo.rijkswaterstaat.nl/services/ogc/gdr/ror_overstromingsrisico/ows?SERVICE=WMS&verwsion=1.3.0',
          layers: 'ror_overstromingsrisico_v_ab',
        },
        {
          title: 'Significant overstromingsrisico lijnen',
          type: 'wms',
          url: 'https://geo.rijkswaterstaat.nl/services/ogc/gdr/ror_overstromingsrisico/ows?service=WMS&version=1.3.0',
          layers: 'ror_overstromingsrisico_l',
        },
        {
          title: 'Buisleidingen',
          type: 'wms',
          url: 'https://rev-portaal.nl/geoserver/wms/rev_public',
          layers: 'bl_buisleidingreferentie',
        },
        {
          title: 'Gevaarlijke Stoffen',
          type: 'wms',
          url: 'https://rev-portaal.nl/geoserver/wms/rev_public',
          layers: 'ev_locatie_activiteiten,qs_ev_activiteiten',
        },
        {
          title: 'Evenementlocaties',
          type: 'wms',
          url: 'https://servicespub.risicokaart.nl/geoserver/ISOR_RK/wms',
          layers: 'isor_evenementlocatie',
        },
        {
          title: 'Kwetsbare objecten',
          type: 'wms',
          url: 'https://data.rivm.nl/geo/alo/wms',
          layers: 'isor_kwo_23122022_v2',
        },
        {
          title: 'Aandachtsgebieden',
          type: 'wms',
          url: 'https://rev-portaal.nl/geoserver/wms/rev_public',
          layers: 'rev_public:qs_aandachtsgebieden',
        },
        {
          title: 'Vervoer en buisleidingen',
          type: 'wms',
          url: 'https://rev-portaal.nl/geoserver/wms/rev_public',
          layers: 'rev_public:qs_vervoer_en_buisleidingen',
        },
        {
          title: 'Contouren en veiligheidsafstanden',
          type: 'wms',
          url: 'https://rev-portaal.nl/geoserver/wms/rev_public',
          layers: 'rev_public:qs_prcontouren_en_veiligheidsafstanden',
        },
        {
          title: 'Openbare drinkwaterkranen',
          type: 'wms',
          url: 'https://data.rivm.nl/geo/alo/wms',
          layers: 'rivm_drinkwaterkranen_actueel',
        },
      ],
    },
    {
      title: 'Reddingsbrigades',
      type: 'group',
      layers: [
        {
          title: 'Reddingsbrigades (incompleet)',
          // Incompleet omdat niet van alle punten coördinaten worden geëxporteerd.
          type: 'kml',
          url: 'https://www.google.com/maps/d/kml?forcekml=1&mid=1ZS4HjriffkjZZAvJm8JAeHH_kqOd-dEI&lid=AvGdMI22drc',
        },
        {
          title: 'Reddingsposten',
          type: 'kml',
          url: 'https://www.google.com/maps/d/kml?forcekml=1&mid=1ZS4HjriffkjZZAvJm8JAeHH_kqOd-dEI&lid=z68dXM7JL5mY.kefqF5EC8xf0',
        },
        {
          title: 'Nationale Reddingsvloot',
          type: 'kml',
          url: 'https://www.google.com/maps/d/kml?forcekml=1&mid=1ZS4HjriffkjZZAvJm8JAeHH_kqOd-dEI&lid=zED5Vfvxvsyw.kH55-jKNc-gY',
        },
      ],
    },
    {
      title: 'Individuals',
      type: 'group',
      layers: [
        {
          title: 'Open Sea Map',
          type: 'osm',
          url: 'https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png',
          source: {
            opaque: false,
          },
        },
        {
          title: 'Landelijk Grondgebruik Nederland',
          type: 'wms',
          url: 'https://service.pdok.nl/wur/landelijk-grondgebruik-nederland/wms/v1_0?service=WMS',
          layers: 'lgn-actueel',
        },
        {
          title: 'Publiekrechtelijke Beperkingen (Wkpb)',
          type: 'mapboxStyle',
          url: 'https://api.pdok.nl/kadaster/brk-publiekrechtelijke-beperkingen-wkpb/ogc/v1/styles/wkpb_standaardvisualisatie__webmercatorquad?f=mapbox',
        },
        {
          title: 'BRP Gewasperselen',
          type: 'wms',
          url: 'https://service.pdok.nl/rvo/brpgewaspercelen/wms/v1_0',
          layers: 'BrpGewas',
          layer: {
            minZoom: 13.5,
          },
        },
        {
          // DEPRECATED 18 novm 2026
          title: 'PDOK labels (DEPRECATED)',
          type: 'wmts',
          projection: 'EPSG:28992',
          url: 'https://service.pdok.nl/bzk/luchtfotolabels/wmts/v1_0?',
          source: {
            layer: 'lufolabels',
          },
          layer: {
            type: '',
            maxZoom: 19.5,
            minZoom: 12.5,
          },
        },
        {
          title: 'PDOK labels',
          type: 'wmts',
          projection: 'EPSG:28992',
          url: 'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0',
          source: {
            layer: 'labels',
          },
          layer: {
            type: '',
            maxZoom: 19.5,
          },
        },
        {
          title: 'PDOK labels OGC webmercator',
          type: 'mapboxStyle',
          url: 'https://api.pdok.nl/kadaster/brt-achtergrondkaart/ogc/v1/styles/luchtfoto_labels__webmercatorquad?f=json',
        },
        {
          title: 'OSM-Overlay',
          type: 'wms',
          url: 'https://ows.terrestris.de/osm/service',
          layers: 'OSM-Overlay-WMS',
        },
        {
          title: 'Mapbox Vector Overlay',
          type: 'mapboxStyle',
          url: mapboxStyle('standard-satellite'),
        },
        {
          title: 'Mapy Labels and borders',
          type: 'tilejson',
          url: mapy('names-overlay'),
          source: {
            attributions: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
            maxZoom: 20,
          },
        },
        {
          title: 'Windsnelheden 100m',
          type: 'wms',
          url: 'https://service.pdok.nl/rvo/windkaart/wms/v1_0',
          layers: 'windsnelheden100m',
          layer: {
            opacity: 0.7,
          },
        },

      ],
    },
  ],
})
